import React, {PropTypes } from 'react';

export class ShowMoreButton extends React.Component {

  static propTypes = {
    text: PropTypes.string.isRequired,
    classes: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    callback: PropTypes.func,
    graySpinner: PropTypes.string,
    disabled: PropTypes.bool,
    type: PropTypes.string,
    id: PropTypes.string
  };

  constructor (props) {
    super(props);
    this.callCallback = this.callCallback.bind(this);
  }

  callCallback (e) {
    if (!this.props.loading && typeof this.props.callback === 'function') {
      this.props.callback(e);
    }
  }

  render () {
    var classes = this.props.classes;

    return (
      <button id={this.props.id} type={(this.props.type) ? this.props.type : 'submit'}
        className={'loyalty-points-show-more-button ' + {classes}}
        onClick={this.callCallback}
        disabled={this.props.disabled}>
        {this.props.text}
      </button>
    );
  }
}

export default ShowMoreButton;




/** WEBPACK FOOTER **
 ** ./src/views/loyalty-program/points-tables/show-more-button.js
 **/